import {Component, Input, input, OnChanges, OnInit, output, SimpleChanges} from '@angular/core';
import {SharedModule} from "../../shared.module";
import {Camera, CameraResultType, CameraSource} from "@capacitor/camera";
import {NgIf} from "@angular/common";
import {ImageService} from "../../service/image.service";

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss'],
  imports: [
    SharedModule,
    NgIf
  ],
  standalone: true
})
export class UploadImageComponent implements OnInit, OnChanges {

  accepts: string[] = ['jpg', 'png'];

  @Input() image: UploadResultType;

  change = output<UploadResultType>();

  constructor(private imageService: ImageService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit() {
  }

  async openGallery() {
    const image = await Camera.getPhoto({
      resultType: CameraResultType.Base64,
      source: CameraSource.Photos,
      quality: 90
    });

    const file = ImageService.base64ToFile(ImageService.concatBase64Type(image.format, image.base64String), 'photo.jpg', image.format === 'png' ? 'image/png' : 'image/jpeg');

    // Resize
    this.imageService.resizeImageToFormat(file).subscribe((result: any) => {
      const resizedFile = result.file;
      const base64 = result.base64;

      this.image = {
        content: base64,
        extension: image.format,
        type: 'base64'
      };

      this.change.emit(this.image);
    });

  }


}

export interface UploadResultType {
  content: string;
  extension?: string;
  type: 'url' | 'base64';
}
